import { render, staticRenderFns } from "./addOrEdit.vue?vue&type=template&id=52a71111"
import script from "./addOrEdit.vue?vue&type=script&lang=js"
export * from "./addOrEdit.vue?vue&type=script&lang=js"
import style0 from "./addOrEdit.vue?vue&type=style&index=0&id=52a71111&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports